/**
 * Contiene la definición inicial para el objeto fabricante
 * @returns {{ocultar_productos: boolean, direccion: string, telefono_de_emergencia: string, telefono: number, nombre: string}}
 */
export const defaultFabricante = () => {
  return {
    nombre: '',
    direccion: '',
    telefono: '',
    telefono_de_emergencia: '',
    ocultar_productos: false
  }
}

/**
 * Contiene la definición inicial para el objeto filtro
 * @returns {{perPage: number, sortBy: string, page: number, sort: string, nombre: string}}
 */
export const defaultFiltro = () => {
  return {
    busqueda: '',
    nombre: '',
    state: [1],
    ocultar_productos: false,
    page: 1,
    paginate: true,
    perPage: 10,
    sortBy: 'nombre',
    sort: 'ASC',
  }
}

export const filtroProcesosAgendados = () => {
  return {
    busqueda: '',
    state: [1],
    ocultar_productos: false,
    page: 1,
    paginate: true,
    perPage: 10,
    sortBy: 'nombre',
    sort: 'ASC',
  }
}

/**
 * Carga todas las variables declaradas en el proceso.
 */
export default {
  fabricantes: [],
  procesosEnSegundoPlano: [],
  fabricante: defaultFabricante(),
  filtro: defaultFiltro(),
  loading: false,
  filtroProcesosAgendados: filtroProcesosAgendados(),
  modal_detail_fabr: { show: false },
}
